import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode; fallback?: ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: { componentStack?: string }) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info.componentStack ?? '');
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-bg-base text-white p-6">
          <h1 className="text-xl font-semibold mb-2 text-rose-400">Something went wrong</h1>
          <div className="text-lg font-semibold bg-rose-950/50 p-3 rounded-lg border border-rose-400 mb-3">
            {this.state.error.name}: {this.state.error.message}
          </div>
          <button
            className="mt-4 bg-bg-panel hover:bg-bg-hover border border-border px-3 py-1.5 rounded text-sm"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
